import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { VStack } from '@components/base/layout';
import { Text } from '@components/base/display';
import { RuleContextProvider } from '@components/shared/configurable';
import { TaskListCardConfigurable as TaskListCard } from '../components/register';
import { useClaimFlowAuthStore } from '../auth/store';
import { buildDashboardRuleContext } from '../contextVariables';

export function DashboardPage() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  const spoofedSessionId = useClaimFlowAuthStore((s) => s.spoofedSessionId);

  // Rule context — see `../contextVariables.ts` for the schema + factory.
  const ruleContextValue = useMemo(
    () => buildDashboardRuleContext({ spoofedSessionId, tenantSlug }),
    [spoofedSessionId, tenantSlug],
  );

  return (
    <RuleContextProvider value={ruleContextValue}>
      <div className="w-full p-6">
        <VStack gap={6}>
          <div>
            <Text as="h1" size="2xl" weight="bold">
              Tableau de bord
            </Text>
            <Text size="sm" color="muted">
              Gérez vos tâches de sinistres en cours
            </Text>
          </div>
          <TaskListCard />
        </VStack>
      </div>
    </RuleContextProvider>
  );
}
